'use client'

import Image from 'next/image'
import { useState } from 'react'

import ZCategoryNavigation from '@/_components/universal/z-category-navigation'
import { cn } from '@/_lib/utils'
import { IAmbulanceCategory } from '@/_types'

import AAmbulanceCategoryList from './a-ambulance-category-list'

interface IProps {
	ambulanceCategory: IAmbulanceCategory
	allAmbulanceCategories: IAmbulanceCategory[]
	showIllustration?: boolean
}

const AAmbulanceCategory: React.FC<IProps> = ({
	ambulanceCategory,
	allAmbulanceCategories,
	showIllustration = false
}) => {
	const [userSearch, setUserSearch] = useState('')

	return (
		<section
			id={ambulanceCategory.slug}
			className={cn(
				'box_complex-health pdt-50 pdb-20 pos_rel',
				ambulanceCategory.sectionTheme &&
					`box_complex-health_${ambulanceCategory.sectionTheme}`,
				showIllustration && 'relative'
			)}
		>
			<div className='wrapper dflex_lgm flex-dir-column'>
				<ZCategoryNavigation
					categories={allAmbulanceCategories || []}
					activeCategory={ambulanceCategory?.slug}
					useHash={true}
					className='box_complex-health_nav nobord pos_rel anim_delay anim_drop1 observe'
					sectionTheme={ambulanceCategory?.sectionTheme}
					categoryNameKey='nameSingular'
					onSearch={setUserSearch}
				/>

				<AAmbulanceCategoryList
					ambulanceCategory={ambulanceCategory}
					searchValue={userSearch}
					initialColumns={3}
				/>
			</div>

			{showIllustration && (
				<Image
					unoptimized={true}
					className='hidden md:block absolute bottom-0 -right-[410px] opacity-50 pointer-events-none'
					src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/illustrations/long-wave/long-medante-wave-purple-black.svg`}
					alt='Ilustračná vlnka'
					height={94}
					width={636}
				/>
			)}
		</section>
	)
}

export default AAmbulanceCategory
